import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F5F3ED', paddingTop: '80px' }}>
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-5xl font-light mb-8" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
          Terms of Service
        </h1>
        
        <div className="bg-white rounded-lg p-8 shadow-sm mb-8">
          <p className="text-sm text-gray-500 mb-8">Last Updated: November 2025</p>
          
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing or using Trove's investment platform and services ("Services"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our Services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                2. Eligibility
              </h2>
              <p>
                To use our Services, you must:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Be at least 18 years of age</li>
                <li>Be a resident of Australia</li>
                <li>Have the legal capacity to enter into a binding contract</li>
                <li>Provide accurate and complete information during registration</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                3. Account Registration and Security
              </h2>
              <p>
                You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must notify us immediately of any unauthorized access or security breach.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                4. Investment Services
              </h2>
              <p className="mb-3">
                Trove provides investment management services, including:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Portfolio construction and management</li>
                <li>Investment in multi-asset portfolios</li>
                <li>Automated rebalancing</li>
                <li>Goal-based investment planning</li>
              </ul>
              <p className="mt-3 font-semibold">
                Important: All investments carry risk. Past performance does not guarantee future results. You may lose some or all of your invested capital.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                5. Fees and Charges
              </h2>
              <p>
                Our fee structure is detailed in our fee schedule and includes:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Management fees (0.8-1.5% per annum based on portfolio complexity)</li>
                <li>Performance fees (10-20% of returns above benchmark)</li>
                <li>Transaction costs (as applicable)</li>
              </ul>
              <p className="mt-3">
                Fees are deducted from your account balance. We reserve the right to modify our fees with 30 days' notice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                6. Deposits and Withdrawals
              </h2>
              <p>
                Minimum initial investment: $500 AUD. Withdrawals are processed monthly and may be subject to liquidity constraints. You must provide adequate notice for withdrawal requests as specified in your portfolio's terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                7. Investment Risks
              </h2>
              <p>
                You acknowledge and accept that:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Investment values fluctuate and may decrease</li>
                <li>Past performance is not indicative of future results</li>
                <li>No guarantee of returns or capital preservation is provided</li>
                <li>Illiquid assets may not be readily convertible to cash</li>
                <li>Economic, market, and regulatory factors affect investment performance</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                8. Prohibited Activities
              </h2>
              <p>
                You may not:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Use the Services for illegal purposes</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with the proper functioning of the Services</li>
                <li>Misrepresent your identity or provide false information</li>
                <li>Violate any applicable laws or regulations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                9. Intellectual Property
              </h2>
              <p>
                All content, trademarks, and intellectual property on our platform are owned by Trove or our licensors. You may not reproduce, distribute, or create derivative works without our express permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                10. Limitation of Liability
              </h2>
              <p>
                To the maximum extent permitted by law, Trove shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Services. Our total liability shall not exceed the fees paid by you in the 12 months preceding the claim.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                11. Termination
              </h2>
              <p>
                Either party may terminate this agreement with 30 days' written notice. We may suspend or terminate your account immediately for breach of these Terms. Upon termination, you must withdraw your funds within the specified redemption period.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                12. Governing Law
              </h2>
              <p>
                These Terms are governed by the laws of Victoria, Australia. Any disputes shall be resolved in the courts of Victoria.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
                13. Contact Information
              </h2>
              <p>
                For questions about these Terms, contact us at:
              </p>
              <p className="mt-3">
                <strong>Email:</strong> legal@trove.com.au<br />
                <strong>Address:</strong> Level 12, 123 Collins Street, Melbourne VIC 3000
              </p>
            </section>
          </div>
        </div>

        <div className="text-center">
          <Link 
            to="/" 
            className="text-[#FF8C42] hover:text-[#FFB366] font-medium"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;